<template>
    <div class="app">
        <AppHeader />
        <router-view />
        <AppFooter />

        <CartModal />
    </div>
</template>

<script>
import AppHeader from "../../components/layout/AppHeader";
import AppFooter from "../../components/layout/AppFooter";
import CartModal from "../../components/layout/CartModal";
export default {
    components: {
    AppHeader,
    AppFooter,
    CartModal
  }
}
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
}
</style>
